import { render, staticRenderFns } from "./sort_list.vue?vue&type=template&id=4d783fa2&scoped=true&"
import script from "./sort_list.vue?vue&type=script&lang=js&"
export * from "./sort_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d783fa2",
  null
  
)

export default component.exports